import { render, staticRenderFns } from "./funding-adequacy-indicator.html?vue&type=template&id=1d675634&"
import script from "./FundingAdequacyIndicator.vue?vue&type=script&lang=js&"
export * from "./FundingAdequacyIndicator.vue?vue&type=script&lang=js&"
import style0 from "./FundingAdequacyIndicator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports